import React from 'react';
import { Checkbox } from '@oneaudi/unified-web-components';
import { useSelector } from 'react-redux';
import PinIcon from '../../assets/icons/PinIcon';
import { MARKET } from '../../constants/market';
import { GeoJSONProperties } from '../../hooks/useDealershipList';
import {
  DealerItem,
  DealerItemInfoContainer,
  DealerNameLabel,
  DealerCityLabel,
  AddressIconWrapper,
} from './DealersSelector.styles';
import { dealerSelectAnalyticsEvent } from '../../utils/analyticsEventListeners';
import { selectDealersList } from '../../reducers/dealersListReducer';

interface DealersListProps {
  name: string;
  city: string;
  region: string;
  selected: boolean;
  dealerId: string;
  dealerProperties: GeoJSONProperties;
  onChange: (dealerId: string) => void;
  distance?: string;
}

const DealersListItem: React.FC<DealersListProps> = ({
  name,
  city,
  region,
  selected,
  dealerId,
  dealerProperties,
  distance,
  onChange,
}) => {
  const { radius, dealersWithinRadius, centerLocation, selectedDealersIds } =
    useSelector(selectDealersList);

  const handleChange = () => {
    const select = !selectedDealersIds.includes(dealerId);
    // Analytics event
    dealerSelectAnalyticsEvent(
      dealerProperties,
      radius.toString(),
      dealersWithinRadius.length,
      select,
      centerLocation,
      `${distance}${MARKET === 'CAN' ? 'km' : 'mi'}`,
    );
    onChange(dealerId);
  };

  return (
    <DealerItem>
      {/* <Checkbox onChange={handleChange} checked={selected} inputId={dealerId} required /> */}
      <DealerItemInfoContainer>
        <Checkbox
          onChange={handleChange}
          checked={selected}
          id={dealerId}
          required
          name="dealer-checkbox"
          value={dealerId}
          label={name}
          hint={`${city},${region}`}
        />
        {/* <div onChange={handleChange}>
          <DealerNameLabel>{name}</DealerNameLabel>
          <DealerCityLabel>
            {city},{region}
          </DealerCityLabel>
        </div> */}
      </DealerItemInfoContainer>
      <AddressIconWrapper>
        <PinIcon />
        <div>{MARKET === 'CAN' ? `${distance} km` : `${distance} miles`}</div>
      </AddressIconWrapper>
    </DealerItem>
  );
};

export default DealersListItem;
